import React from 'react'

export default function() {
  return (
    <main id="Dohodnina">
      <div className="py-5 bg-light">
        <div className="container">
          <h2 className="mb-4"> Zahteva za namenitev dela dohodnine za donacije</h2>
          <p>Spoštovane ljubiteljice in ljubitelji naše godbe.</p>
          <p>
            Veseli bomo, če boste del dohodnine (maksimalno 0,5%), ki jo plačate državi, namenili za delovanje našega
            društva.
          </p>
          <p>To storite tako, da izpolnite spletni obrazec, ki smo ga pripravili za vas.</p>
          <p>
            Podpisan zahtevek je potrebno oddati na pristojni davčni urad oziroma izpostavo in to osebno ali po pošti.
            Lahko pa obrazec pošljete na naš naslov in bomo mi uredili vložitev <a href="#pripis-1">*</a>.
          </p>
          <p>
            Zavezanci, ki imate digitalno potrdilo, pa lahko zahtevo oddate elektronsko preko portala{' '}
            <a href="http://edavki.durs.si" target="_blank" rel="noopener noreferrer">
              eDavki
            </a>{' '}
            oz. na strani za{' '}
            <a
              href="https://edavki.durs.si/EdavkiPortal/OpenPortal/CommonPages/Opdynp/PageD.aspx?category=namenitev_dela_dohodnine_fo"
              rel="noopener noreferrer"
              target="_blank"
            >
              namenitev dela dohodnine za donacije
            </a>
            .
          </p>

          <p id="#pripis-1" className="text-secondary" style={{ fontSize: '0.9rem' }}>
            *KD Godba Zgornje Savinjske doline bo osebne podatke hranila do vašega preklica. Uporabo vaših osebnih
            podatkov lahko kadarkoli prekličete na naš naslov ali pa na{' '}
            <a href="mailto:info@godba.org" target="_top">
              info@godba.org
            </a>
          </p>

          <p className="font-weight-bold mb-0" style={{ fontSize: '1.5rem' }}>
            Naši podatki:
          </p>
          <p className="font-weight-bold" style={{ fontSize: '1.5rem' }}>
            KD Godba Zgornje savinjske doline, Hribernikova 1, 3330 Mozirje (davčna številka: 38987147).
          </p>

          <iframe
            title="Dohodnina"
            frameBorder="0"
            width="100%"
            height="625"
            style={{ marginTop: '20px' }}
            src="https://www.cnvos.si/nulapet/embed/?address=Hribernikova%20ulica%201&amp;city=Mozirje&amp;name=KULTURNO%20DRUŠTVO%20GODBA%20ZGORNJE%20SAVINJSKE%20DOLINE&amp;postalCode=3330&amp;taxNumber=38987147"
          />
        </div>
      </div>
    </main>
  )
}
